// import node module libraries
import { Fragment } from 'react';

// import sub components
import HeaderBreadcrumb from '../HeaderBreadcrumb';
import AllFAQsList from './AllFAQsList';
import SEO from 'components/marketing/seo/Seo';

const HelpCenterFAQ = () => {
	const breadcrumb = [
		{
			page: 'Help Center',
			link: '/marketing/help-center/'
		},
		{
			page: 'Meist gestellte Fragen (FAQ)',
			link: '#'
		}
	];

	return (
		<Fragment>
			<SEO
				title="Help Center FAQ"
				description="Du hast Fragen zu unseren Schnittstellen, Preisen oder Integrationen? Finde Antworten in unseren FAQ oder kontaktiere unser Team."
				keywords="kontakt saas plattform, support multi channel e-commerce"
				canonical="https://haeppy.app/marketing/help-center/faq/"
			/>
			{/* header and breadcrumb */}
			<HeaderBreadcrumb
				title="Meist gestellte Fragen (FAQ)"
				breadcrumb={breadcrumb}
			/>
			{/* Most asked, General inquiries and Support FAQs section */}
			<AllFAQsList />
		</Fragment>
	);
};
export default HelpCenterFAQ;
